// src/services/documentHelpers.js
// Порт из панели водителя; firestore и реквизиты фирмы (firm) — через параметры (мультипроект).
import { doc, getDoc } from 'firebase/firestore';

export const generateContractNumber = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
  return `${year}/${month}/${day}/${random}`;
};

export const extractCityFromAddress = (address) => {
  if (!address) return null;
  const patterns = [/\d{2}-\d{3}\s+([^,]+)/, /,\s*([^,]+)\s*$/, /ul\.\s+[^,]+,\s*([^,]+)/];
  for (const pattern of patterns) {
    const match = address.match(pattern);
    if (match) return match[1].trim();
  }
  return null;
};

export const formatPolishDate = (date) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('pl-PL', options);
};

export const prepareReplacementData = async (firestore, userId, firm = {}, includeSignature = false, signatureUrl = null) => {
  const userDoc = await getDoc(doc(firestore, 'users', userId));
  if (!userDoc.exists()) throw new Error(`Użytkownik ${userId} nie istnieje`);
  const userMainData = userDoc.data() || {};

  const danePersonalneDoc = await getDoc(doc(firestore, 'users', userId, 'dokumenty', 'dane_personalne'));
  const personalData = danePersonalneDoc.exists() ? danePersonalneDoc.data() : {};

  const carDoc = await getDoc(doc(firestore, 'users', userId, 'dokumenty', 'samochod'));
  const carData = carDoc.exists() ? carDoc.data() : {};

  const currentDate = formatPolishDate(new Date());
  const contractNumber = generateContractNumber();
  const fullName = `${userMainData.firstName || ''} ${userMainData.lastName || ''}`.trim() || 'Nie określono';

  const address = personalData.registrationAddress || personalData.correspondenceAddress ||
    personalData.residenceAddress || personalData.street || 'Nie określono';
  const city = personalData.city || extractCityFromAddress(address) || 'Nie określono';
  const postalCode = personalData.postalCode || '';

  let fullAddress = address;
  if (city !== 'Nie określono' && !address.includes(city)) {
    fullAddress = `${address}, ${postalCode} ${city}`.replace(/,\s*,/g, ',').trim();
  }

  let driverSignatureHTML = '<div class="signature-line"></div>';
  let companySignatureHTML = '<div class="signature-line"></div>';
  if (includeSignature && signatureUrl) {
    driverSignatureHTML = `<div class="signature-container"><img src="${signatureUrl}" class="signature-image" style="height: 40px; max-width: 100px; display: block; margin: 5px 0;" alt="Podpis kierowcy" /></div>`;
  }
  if (includeSignature && firm.stampUrl) {
    companySignatureHTML = `<div class="signature-container"><img src="${firm.stampUrl}" class="signature-image" style="height: 80px; max-width: 100px; display: block; margin: 5px 0;" alt="Pieczątka firmy" /></div>`;
  }

  return {
    'PLACEHOLDER_FIRST_NAME': userMainData.firstName || '',
    'PLACEHOLDER_LAST_NAME': userMainData.lastName || '',
    'PLACEHOLDER_DRIVER_NAME': fullName,
    'PLACEHOLDER_DRIVER_ADDRESS': fullAddress,
    'PLACEHOLDER_DRIVER_CITY': city,
    'PLACEHOLDER_DRIVER_PESEL': personalData.pesel || 'Nie określono',
    'PLACEHOLDER_REGISTRATION_ADDRESS': fullAddress,
    'PLACEHOLDER_DATE': currentDate,
    'PLACEHOLDER_CURRENT_DATE': currentDate,
    'PLACEHOLDER_CONTRACT_DATE': currentDate,
    'PLACEHOLDER_CONTRACT_NUMBER': contractNumber,
    'PLACEHOLDER_COMPANY_NAME': firm.companyName || '',
    'PLACEHOLDER_COMPANY_NIP': firm.nip || '',
    'PLACEHOLDER_COMPANY_ADDRESS': firm.address || '',
    'PLACEHOLDER_COMPANY_KRS': firm.krs || '',
    'PLACEHOLDER_CAR_MAKE': carData.carMake || 'Nie określono',
    'PLACEHOLDER_CAR_MODEL': carData.carModel || 'Nie określono',
    'PLACEHOLDER_CAR_YEAR': carData.carYear || 'Nie określono',
    'PLACEHOLDER_CAR_VIN': carData.carVin || 'Nie określono',
    'PLACEHOLDER_CAR_REGISTRATION_NUMBER': carData.carRegistrationNumber || 'Nie określono',
    'PLACEHOLDER_CITIZENSHIP': personalData.citizenship || userMainData.citizenship || 'Polska',
    'PLACEHOLDER_SIGNATURE_DRIVER': driverSignatureHTML,
    'PLACEHOLDER_SIGNATURE_COMPANY': companySignatureHTML,
  };
};

export const replacePlaceholders = (html, replacements) => {
  let processedHtml = html;
  const sortedKeys = Object.keys(replacements).sort((a, b) => b.length - a.length);
  sortedKeys.forEach((placeholder) => {
    const value = replacements[placeholder] || '';
    processedHtml = processedHtml.replace(new RegExp(placeholder, 'g'), value);
  });
  return processedHtml;
};
